import { SaleFormInput } from '@src/core/buyerApiClient';
import { formInputGroupKey } from '@src/domains/orders/core/form-inputs/formInputGroupKey';

/** Draft values, indexed by the input `hash`. */
export type FormInputValues = Record<string, string>;

/**
 * The value that counts for an input: the local draft wins over what the server
 * returned, including when the draft is an empty string and the buyer cleared it.
 */
export const resolveFormInputValue = (input: SaleFormInput, values: FormInputValues): string =>
  values[input.hash] ?? input.value ?? '';

/**
 * Whitespace does not count as filled: letting it through would move the buyer on to
 * payment and issue a voucher without the required data.
 */
export const isFormInputGroupFilled = (inputs: SaleFormInput[], values: FormInputValues): boolean =>
  inputs.length > 0 && inputs.every((input) => resolveFormInputValue(input, values).trim() !== '');

export const countFilledFormInputGroups = (formInputGroups: Array<SaleFormInput[]>, values: FormInputValues): number =>
  formInputGroups.filter((inputs) => isFormInputGroupFilled(inputs, values)).length;

/**
 * Where the wizard should open a row. The units of a tariff are not filled in order —
 * the server can return values for the second one and none for the first — so the
 * position has to come from what is missing, never from how many are done.
 */
export const firstPendingFormInputGroupKey = (
  formInputGroups: Array<SaleFormInput[]>,
  values: FormInputValues,
): string =>
  formInputGroupKey(
    formInputGroups.find((inputs) => !isFormInputGroupFilled(inputs, values)) ?? formInputGroups[0] ?? [],
  );
